import React, { useState, useEffect } from 'react';

import { AlertMessage } from "components";

import { func_validation } from "functions";

export function useAlertMessage(props) {
    const { 
        addAccount_errorMsg,
        updateAccount_errorMsg,

        isFormSubmissionAttempted
    } = props;

    const [alertMsg, setAlertMsg] = useState("");
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);

    function handleError(errorMsg) {
        if (func_validation.isStringTrimNotEmpty(errorMsg) && 
            isFormSubmissionAttempted) {

            setAlertMsg(errorMsg);
            setIsAlertMsgVisible(true);
        }
    }
    useEffect(() => {
        handleError(addAccount_errorMsg);
    }, [addAccount_errorMsg]);
    useEffect(() => {
        handleError(updateAccount_errorMsg);
    }, [updateAccount_errorMsg]);

    let alertMessageDisplay = isAlertMsgVisible? (
        <div className={"pb-3"}>
            <AlertMessage
                message={alertMsg}
                isVisible={isAlertMsgVisible}
                toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
            />
        </div>
    ):"";

    return {
        alertMessageDisplay
    };
}